








import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {SCRIPTLOADER_SERVICE_INSTANCE} from '@/services/scriptloader.service';
import {Location} from '@/views/timeline/services/googlemaps/location';
import {DisguiseBusinessExceptionWrapper} from '../../exception/disguise-business-exception-wrapper';

declare const google: any;

@Component
export default class AmetrasMapsFieldTemplate extends Vue {
  @Prop() value!: string;
  @Prop() drawMap!: boolean;

  lastLocation: Location[] = [];
  loading: boolean = false;

  $refs!: {
    map: HTMLDivElement
  };

  googleMapsInstance: any;

  created() {
    this.loading = true;
    const url = `/backend/api/v0/google/key`;
    HTTP_SERVICE_INSTANCE.getAxios().get(url).then((response: any) => {
      SCRIPTLOADER_SERVICE_INSTANCE
          .loadScript(`https://maps.googleapis.com/maps/api/js?key=${response.data.key}`).then(() => {
        if (this.value) {
          this.initMap(JSON.parse(this.value));
        } else {
          this.loading = false;
        }
      }).catch((error) => {
        if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
          this.$store.commit('showSnack', {
            message: 'Google Maps API nicht verfügbar',
            color: 'error'
          });
        }
        this.loading = false;
      });
    }).catch((error) => {
      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
        this.$store.commit('showSnack', {
          message: 'GMaps API Key konnte nicht geladen werden.',
          color: 'error'
        });
      }
      this.loading = false;
    });
  }

  @Watch('value') changedLocations(newValue: string) {
    this.initMap(JSON.parse(newValue));
  }

  public initMap(locations: Location[]) {
    this.loading = true;
    if (locations === this.lastLocation) {
      return; // same locations again - dont query
    }
    this.lastLocation = locations;
    if (this.$refs.map) {
      this.googleMapsInstance = new google.maps.Map(this.$refs.map, {
        zoom: 6,
        center: new google.maps.LatLng(51.269329, 10.4787362), // Center Germany
      });
      const url = '/backend/api/v0/google/coords';
      return HTTP_SERVICE_INSTANCE.getAxios()
          .post(url, JSON.stringify(this.lastLocation)).then((response: any) => {
            const result: DisguiseDto.GMapsCoordsDto[] = response.data;
            if (result) {
              for (const [index, coord] of result.entries()) {
                const marker = new google.maps.Marker({
                  position: new google.maps.LatLng(coord.lat, coord.lng),
                  map: this.googleMapsInstance
                });
                const infowindow = new google.maps.InfoWindow();
                google.maps.event.addListener(marker, 'click', ((clickedMarker) => {
                  return () => {
                    infowindow.setContent(coord.infoText);
                    infowindow.open(this.googleMapsInstance, clickedMarker);
                  };
                })(marker));
              }
            }
            this.loading = false;
          });
    } else {
      this.$store.commit('showSnack', {
        message: 'Map Element nicht gefunden',
        color: 'error'
      });
      this.loading = false;
    }
  }
}
